<template>
  <main id="account" class="page-container">
    <!-- <p
      v-if="errorMessage"
      :class="{ 'error-message': true, show: errorMessage }"
    >
      {{ errorMessage }}
    </p>
    <p
      v-if="errorMessage2"
      :class="{ 'error-message': true, show: errorMessage2 }"
    >
      {{ errorMessage2 }}
    </p>
    <p
      v-if="successMessage"
      :class="{ 'success-message': true, show: successMessage }"
    >
      {{ successMessage }}
    </p>
    <p
      v-if="successMessage2"
      :class="{ 'success-message': true, show: successMessage2 }"
    >
      {{ successMessage2 }}
    </p> -->

    <!-- Form principale -->
    <form class="create-account-form" @submit.prevent="handleSubmit">
      <h3><strong>Cambio Password</strong></h3>
      <!-- RIGA 1: account email, old/new password -->
      <div class="create-account-row row-1">
        <div class="field">
          <label for="account-email1">Email</label>
          <input
            id="account-email1"
            type="email"
            placeholder="Indirizzo email"
            v-model="emailStep1"
            autocomplete="email"
            required
          />
        </div>

        <div class="field" v-if="step === 1">
          <!-- Vecchia Password -->
          <label v-if="step === 1" for="old-password">Vecchia Password</label>
          <div class="account-password-field">
            <input
              v-if="step === 1"
              id="old-password"
              :type="showPassword1 ? 'text' : 'password'"
              placeholder="Inserisci vecchia password"
              v-model="oldPassword"
              autocomplete="current-password"
              required
            />

            <!-- Occhio (o icona) per mostrare/nascondere la password -->
            <button
              type="button"
              class="toggle-password-button"
              @click="togglePassword1"
            >
              <!-- Se showPassword2 è false, mostra icona occhio aperto. Altrimenti, occhio chiuso. -->
              <i v-if="!showPassword1" class="fa-solid fa-eye-slash"></i>
              <i v-else class="fa-solid fa-eye"></i>
            </button>
          </div>
        </div>

        <div class="field" v-if="step === 2">
          <!-- Nuova Password -->
          <label v-if="step === 2" for="account-password1"
            >Nuova Password</label
          >
          <div class="account-password-field">
            <input
              v-if="step === 2"
              id="account-password1"
              :type="showPassword2 ? 'text' : 'password'"
              placeholder="Inserisci nuova password"
              v-model="newPasswordStep2"
              autocomplete="new-password"
              required
            />

            <!-- Occhio (o icona) per mostrare/nascondere la password -->
            <button
              type="button"
              class="toggle-password-button"
              @click="togglePassword2"
            >
              <!-- Se showPassword2 è false, mostra icona occhio aperto. Altrimenti, occhio chiuso. -->
              <i v-if="!showPassword2" class="fa-solid fa-eye-slash"></i>
              <i v-else class="fa-solid fa-eye"></i>
            </button>
          </div>
        </div>

        <div class="save-button-container">
          <button
            type="submit"
            id="change-password"
            :disabled="
              !emailStep1 || (step === 1 ? !oldPassword : !newPasswordStep2)
            "
          >
            {{ step === 1 ? "Verifica vecchia password" : "Aggiorna password" }}
          </button>
        </div>
      </div>
    </form>

    <hr />
    <form class="create-account-form" @submit.prevent="createNewAdmin">
      <h3><strong>Aggiungi admin</strong></h3>
      <!-- RIGA 2: account email, password -->
      <div class="create-account-row row-2">
        <div class="field">
          <!-- account email -->
          <label for="account-email2">Aggiungi admin</label>
          <input
            id="account-email2"
            type="email"
            placeholder="Indirizzo email"
            v-model="emailAdmin"
            autocomplete="email"
            required
          />
        </div>

        <div class="field">
          <!-- password -->
          <label for="get-password">Password</label>
          <div class="account-password-field">
            <input
              id="get-password"
              :type="showAdminPassword ? 'text' : 'password'"
              placeholder="Password"
              v-model="passwordAdmin"
              autocomplete="current-password"
              required
            />

            <!-- Occhio (o icona) per mostrare/nascondere la password -->
            <button
              type="button"
              class="toggle-password-button"
              @click="toggleAdminPassword"
            >
              <!-- Se showAdminPassword è false, mostra icona occhio aperto. Altrimenti, occhio chiuso. -->
              <i v-if="!showAdminPassword" class="fa-solid fa-eye-slash"></i>
              <i v-else class="fa-solid fa-eye"></i>
            </button>
          </div>
        </div>

        <div class="save-button-container">
          <button
            id="add-admin"
            type="submit"
            :disabled="!emailAdmin || !passwordAdmin"
          >
            Aggiungi admin
          </button>
        </div>
      </div>
    </form>
  </main>
</template>

<script>
import { setAuth } from "../router";

export default {
  data() {
    return {
      operatorName: "",
      step: 1, // Step iniziale
      emailStep1: "",
      oldPassword: "",
      newPasswordStep2: "",
      emailAdmin: "",
      passwordAdmin: "",
      errorMessage: "",
      errorMessage2: "",
      successMessage: "",
      successMessage2: "",
      showPassword1: false, // controlla se la password è visibile
      showPassword2: false,
      showAdminPassword: false,
    };
  },
  methods: {
    togglePassword1() {
      // Inverte lo stato showPassword1
      this.showPassword1 = !this.showPassword1;
    },
    togglePassword2() {
      // Inverte lo stato showPassword2
      this.showPassword2 = !this.showPassword2;
    },
    toggleAdminPassword() {
      // Inverte lo stato showAdminPassword
      this.showAdminPassword = !this.showAdminPassword;
    },
    async handleSubmit() {
      if (this.step === 1) {
        // Step 1: Verifica Vecchia Password
        try {
          const payload = {
            email: this.emailStep1,
            password: this.oldPassword,
          };
          const response = await this.$axios.post(
            "/auth/verify-password",
            payload
          );
          // console.log(response);
          if (response.status === 200) {
            this.step = 2; // Passa allo step 2
            this.successMessage =
              "Password verificata! Inserisci la nuova password.";
            this.$toast.success(this.successMessage);
            this.errorMessage = "";
          } else {
            this.errorMessage =
              response.data.details || "Email/password non corretti";
            this.$toast.error(this.errorMessage);
            this.successMessage = "";
          }
        } catch (error) {
          this.errorMessage =
            error.response?.data?.message || "Errore durante la verifica.";
          this.$toast.error(this.errorMessage);
          this.successMessage = "";
          console.error("Errore durante la verifica password:", error);
        }
      } else if (this.step === 2) {
        // Step 2: Aggiorna Nuova Password
        try {
          // [sc-48852] l'API ricontrolla la vecchia password
          const payload = {
            email: this.emailStep1,
            oldPassword: this.oldPassword,
            password: this.newPasswordStep2,
          };
          const response = await this.$axios.patch(
            "/auth/change-password",
            payload
          );
          if (response.status === 200) {
            this.step = 1;
            this.successMessage2 =
              response.data.details || "Password aggiornata con successo!";
            this.$toast.success(this.successMessage2);
            this.emailStep1 = "";
            this.emailAdmin = "";
            this.errorMessage2 = "";
            this.oldPassword = "";
            this.newPasswordStep2 = "";

            setTimeout(() => {
              setAuth(false); // logout
              // push alla login page dopo 2 secondi
              this.$router.push("/login");
              this.$toast.info("Effettua il login con la nuova password.");
            }, 2000);
          } else {
            this.errorMessage2 =
              response.data.details || "Password già aggiornata alla modifica";
            this.$toast.error(this.errorMessage2);
            this.successMessage2 = "";
          }
        } catch (error) {
          this.errorMessage2 =
            error.response?.data?.message || "Errore durante l'aggiornamento.";
          this.$toast.error(this.errorMessage2);
          this.successMessage2 = "";
          console.error("Errore durante l'aggiornamento password:", error);
        }
      }
    },
    async createNewAdmin() {
      this.errorMessage = "";
      this.successMessage = "";
      try {
        const payload = {
          email: this.emailAdmin,
          password: this.passwordAdmin,
        };
        const response = await this.$axios.post("/auth/create-admin", payload);
        if (response.status === 200) {
          this.successMessage =
            response.data.message || "Admin creato con successo!";
          this.$toast.success(this.successMessage);
          this.emailAdmin = "";
          this.errorMessage = "";
          this.passwordAdmin = "";
        } else {
          this.errorMessage =
            response.data.message || "Errore durante la creazione dell'admin"; //response diversa da 200
          this.$toast.error(this.errorMessage);
          this.successMessage = "";
        }
      } catch (error) {
        this.errorMessage =
          error.response?.data?.details ||
          "Errore durante la creazione dell'admin.";
        this.$toast.error(this.errorMessage);
        this.successMessage = "";
        console.error("Errore durante la creazione dell'admin: ", error);
      }
    },
  },
};
</script>

<style src="@/css/AccountPage.css"></style>
